import cloneDeep from 'lodash.clonedeep';
import { reformatNavigationMenuItem } from './reformatNavigationMenuItem';

/**
 * Add top level menu item
 *
 * @param {Array} menuItemsArray
 * @returns {boolean|Array}
 */
export function addTopLevelFieldToNavigationMenuItemsWithChildren(menuItemsArray) {
  if (!menuItemsArray) return false;
  const arrCopy = cloneDeep(menuItemsArray);
  arrCopy.forEach((parentObject) => {
    reformatNavigationMenuItem(parentObject);
  });

  return arrCopy;
}
